import { FC } from 'react';
import MultiCheckInput from 'components/core/multi-check-input';
import Permissions from 'state/permissions';

interface PermissionPickerProps {
  id: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  handleBlur?: any;
}

const PermissionPicker: FC<PermissionPickerProps> = ({ id, label, required, ...form }) => {
  const options = Permissions.map((p: { value: string; name?: string }) => ({
    value: p.value,
    label: p.name || p.value,
  }));

  return (
    <MultiCheckInput
      id={id}
      label={label ?? 'Permissions'}
      required={required}
      options={options}
      handleBlur={form.handleBlur || (() => undefined)}
      {...form}
    />
  );
};

export default PermissionPicker;
